// @flow
import React from 'react';
import {compose} from 'redux';
import {useQuery} from '@apollo/react-hooks';
import {connect} from 'react-redux';
import {get} from 'lodash';
import {injectIntl} from 'react-intl';
import withLingua from '../withLingua/withLingua';
import type {IntlShape} from 'react-intl';
import type {LinguaProps} from '../withLingua/withLingua';
import type {State as AbacusState} from '../../reducers/abacus';
import type {State as ReduxState} from '../../reducers';
import type {SystemData} from '../../../server/utils/systemData';
import {RecommendedDestinationsCarousel} from '@homeaway/react-property-carousel';
import routerActions from '../../actions/router';
import './DestinationCarousel.less';
import {
    destinationRecommendationsQuery,
    destinationRecommendationsVariables
} from '../../queries/destinationRecommendationsQuery';
import {getTitleKeyByCount} from './helpers';
import {
    BREAKPOINTS,
    SERP_DISCOVER_MORE_DESTINATION,
    RECOMMENDED_DESTINATIONS_MIN_LIMIT
} from './constants';

type OwnProps = {
    locationSearch: typeof routerActions.search,
    isLoading: boolean,
    intl: IntlShape,
    listingsCount: number
};

type StateProps = {
    abacus: AbacusState,
    searchParams: any,
    system: SystemData
};

type Props = OwnProps & StateProps & LinguaProps;

export const DestinationCarouselBottom = ({
    messages,
    locationSearch,
    searchParams,
    abacus,
    system,
    listingsCount
}: Props) => {
    const {loading, data} = useQuery(destinationRecommendationsQuery, {
        variables: destinationRecommendationsVariables(
            searchParams.params,
            abacus,
            system
        )
    });
    if (!loading && !data) {
        return null;
    }
    const recommendationResponse = get(
        data,
        'search.destinationRecommendationResponse',
        {}
    );
    const handleOnClick = (
        evt: SyntheticEvent<HTMLInputElement>,
        position: number
    ) => {
        const index = position - 1;
        const placeNameFull = get(
            recommendationResponse,
            `recommendedDestinations[${index}].breadcrumbs[0].place.name.full`,
            ''
        );

        if (placeNameFull) {
            locationSearch({q: placeNameFull});
        }
    };

    const title = messages[getTitleKeyByCount(listingsCount)];
    return (
        <RecommendedDestinationsCarousel
            breakpoints={BREAKPOINTS}
            customCardClickHandler={handleOnClick}
            data={recommendationResponse}
            minDestinationCount={RECOMMENDED_DESTINATIONS_MIN_LIMIT}
            isLoading={loading}
            scrolling
            isNextGeoLevel
            propertyViewEventFirePosition="bottom"
            target={SERP_DISCOVER_MORE_DESTINATION}
            title={title}
        />
    );
};

const mapStateToProps = (state: ReduxState): StateProps => {
    const {searchParams, abacus, system} = state;

    return {
        searchParams,
        abacus,
        system
    };
};

const mapDispatchToProps = {
    locationSearch: routerActions.locationSearch
};

export default compose(
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps),
    withLingua({
        namespace: 'traveler/react-property-carousel',
        category: 'messages'
    })
)(DestinationCarouselBottom);
